import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>This action triggers when a Stow Associate incorrectly Stows 4+ Non-Oversized packages to Oversized Racks.
      Non-Oversized packages are packages that do not have “Oversized” on the SLAM label.&nbsp;</p>
    <p><strong>Impact</strong></p>
    <p>The Oversized package rack is reserved for packages with “OVERSIZED” on the SLAM label. By stowing non-oversized
      packages to the OV rack, sites may see their oversized rack get overfilled which leads to:</p>
    <ul>
      <li>Increased time spent picking routes (16.5 additional seconds per extra package in the OV stow area)&nbsp;</li>
      <li>Increased time spent loading Vans (14.12 additional seconds per extra package in the OV stow area)</li>
    </ul>
    <p>This action requires the L3+ Leadership team to perform a face to face coaching conversation to understand why the
      associate is stowing non-OV packages into OV rack.</p>
    <p><strong>Resolution Steps</strong></p>
    <p>
      1.Locate the Stow Associate that triggered the Alert. &nbsp;<br/>
      2.Conduct the face to face coaching conversation<br/>
      3.After completing the coaching conversation, close the action&nbsp;&nbsp;
    </p>
    <div className="wikimodel-emptyline"></div>
    <p><strong>Supplemental Links</strong></p>
    <p>&nbsp;</p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_EU_Non_OV_To_OV.jsx